import { Directive, Input, OnInit, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appAbTestItem]',
  standalone: true,
})
export class AbTestItemDirective implements OnInit {

  @Input('appAbTestItem') appAbTestConfig!: AbTestRatio;

  public itemTemplate: TemplateRef<any>;

  constructor(public templateRef: TemplateRef<any>) {}

  ngOnInit() {
    this.itemTemplate = this.templateRef;
  }
}

export interface AbTestRatio {
  ratio: number;
}
